import Container from '@components/UI/Container';

import useBreadcrumbs from '@hooks/useBreadcrumbs';
import PropTypes from 'prop-types';
import React from 'react';

import BreadcrumbsWrap from './BreadcrumbsWrap';

const Breadcrumbs = ({
    wrap,
    pathname=null,
    icon='caret-right',
    showHome=true,
    lastAction=false
}) => {
    const renderBreadcrumbs = useBreadcrumbs(pathname, icon, showHome, lastAction);

    return wrap ? (
        <BreadcrumbsWrap>
            <Container>
                { renderBreadcrumbs }
            </Container>
        </BreadcrumbsWrap>
    ) : ( renderBreadcrumbs );
};

Breadcrumbs.displayName = 'Breadcrumbs';

Breadcrumbs.propTypes = {
    icon: PropTypes.string,
    lastAction: PropTypes.bool,
    pathname: PropTypes.string,
    showHome: PropTypes.bool,
    wrap: PropTypes.bool
};

export default Breadcrumbs;
